<template>
  <AppCard class="pa-4 border" elevation="0">
    <template v-if="importedFiles.length !== 0">
      <div v-if="addFromTemplate" class="mb-4">
        <p class="text-grey-900 text--large text--bold">
          {{$t('project.signing-checklist.add.step2.SigningChecklistAddStep2.fromTemplateTitle')}}
        </p>
        <p class="text-grey-700 text--small">
          {{$t('project.signing-checklist.add.step2.SigningChecklistAddStep2.fromTemplateSubtitle')}}
        </p>
      </div>
      <p v-else class="text-body-1 mb-4">
        <span v-t="{
            path: 'project.signing-checklist.add.step2.SigningChecklistAddStep2.infoHint',
            plural: importedFiles.length,
          }"
        />
      </p>
      <v-expansion-panels>
          <SigningChecklistAddStep2File
            v-for="(file, i) in importedFiles"
            :key="i"
            :file="file"
            @signatureTypeChange="onSignatureTypeChange"
          />
      </v-expansion-panels>
    </template>
    <template v-else>
      <p class="text-center">{{$t('project.signing-checklist.add.step2.SigningChecklistAddStep2.noValidFiles')}}</p>
    </template>
  </AppCard>
</template>

<script lang="ts">
import { defineComponent, inject, PropType } from 'vue'
import { createNamespacedHelpers } from 'vuex'

import { toast } from '@/common/utils/toast'
import { SigningChecklistAddProvidedData, signingChecklistAddInjectionKey } from '@/project/views/inject-keys/signingChecklistAddInjectionKey'
import { SigningChecklistFile } from '@/project/views/SigningChecklistAdd.vue'

import AppCard from '@/common/AppCard.vue'
import SigningChecklistAddStep2File from './SigningChecklistAddStep2File.vue'

const { mapState: mapRoomState } = createNamespacedHelpers('room')

export default defineComponent({
  name: 'SigningChecklistAddStep2',
  components: {
    SigningChecklistAddStep2File,
    AppCard,
  },
  props: {
    importedFiles: {
      type: Array as PropType<Array<SigningChecklistFile>>,
      required: true,
    },
  },
  head () {
    return {
      title: this.$t('project.signing-checklist.add.step2.SigningChecklistAddStep2.metaTitle'),
    }
  },
  setup () {
    const signingChecklistAddProvidedData = inject<SigningChecklistAddProvidedData>(signingChecklistAddInjectionKey)

    return {
      addFromTemplate: signingChecklistAddProvidedData?.addFromTemplate,
    }
  },
  computed: {
    ...mapRoomState(['currentRoom']),
  },
  methods: {
    onSignatureTypeChange (originalFile: SigningChecklistFile, signatureType: string) {
      if (this.importedFiles.length > 1 && this.importedFiles.every((file: SigningChecklistFile) => file.objectToPost.signatureType === '' || file === originalFile)) {
        let updatedSomethingElse = false
        for (const file of this.importedFiles) {
          if (file === originalFile) {
            continue
          }
          const provider = signatureType.split('.')[0]
          const maxSize = this.currentRoom.providers.find((roomProvider: ObjectWith<{ provider: string }>) => roomProvider.provider === provider).maxSize
          if (maxSize > file.size) {
            file.objectToPost.signatureType = signatureType
            updatedSomethingElse = true
          }
        }
        if (updatedSomethingElse) {
          toast.success(this.$t('project.signing-checklist.add.step2.SigningChecklistAddStep2.groupsignatureTypeChange'))
        }
      }
    },
  },
})
</script>
